import React from "react";
import jwt from "jsonwebtoken";;

import { Layout, Menu, Button } from "antd";
import { withRouter, Link } from "react-router-dom";
import Icon from "@material-ui/core/Icon";
// import LogoutIcon from '@material-ui/icons/PowerSettingsNew';
import CloseIcon from "@material-ui/icons/Close";

import { connect } from "react-redux";

import DrawerActions from "../../actions/Drawer";
import AuthActions from "../../../actions/Auth";

import { pushLog2DV2LogServer } from "../../../services/logging";
import {
  StatusConstant,
  CodeConstant,
  ActionConstant,
  PageConstant,
} from "../../constants";

/* dv2 legacy_components */
import { checkBasicChallengesPassed } from "../../legacy_components/components/admin/ChallengeList/services";
/* dv2 legacy_components */

import * as dashboardService from "../../../services/Dashboard";
import TuringLogoText from "../../assets/img/turing_logo_text.svg";
import Lock from "../../assets/img/lock.svg";
import NotificationIcon from "../../assets/img/notification.svg";
import CaretRightIcon from "../../../assets/img/caret-right.svg";
// import { getGCSUrl } from '../../../services/Common';
import "./NavigationDrawer.css";
import HomeActions from "../../legacy_components/UI_V2_Components/home/HomeV1/Home.actions";
import { get, isEqual } from "lodash";
// import moment from 'moment';
import { AvailabilityDetails } from "../../legacy_components/UI_V2_Components/shared/constants/availabilityconstants";
import AvailabilityModalV3 from "../../legacy_components/UI_V2_Components/profile/Modals/availibilityv3.modal";
import { getAvailabilityState } from "../../legacy_components/util/availabilityStateUtil";
import ProfileActions from "../../legacy_components/UI_V2_Components/profile/Profile.actions";
import { withLDFlagsFromBackend, GB_FLAGS } from "../../legacy_components/services/launchDarkly";
import {
  getAvailabilityId,
  AVAILABILITY_STATUS_NAMES,
} from "../../../constants/AvailabilityType";
import {
  COMPARE_STATUS,
  IS_VETTING_USEABLE,
  STATUS
} from "../../legacy_components/constants/status";
import Notifications from "../../components/Notifications/Notifications";
import { TestsActions } from "../../legacy_components/UI_V2_Components/tests/constants";
import TestsActionsDispatch from "../../legacy_components/UI_V2_Components/tests/Tests.actions";
import AvatarDropDown from "./AvatarDropDown/AvatarDropDown";
import JobsActions from "../../legacy_components/UI_V2_Components/jobs/jobs.actions";
import clarityIdentify from "../../../services/clarity";
import canAccessPage from "../../legacy_components/constants/canAccessPage";
import { getUserSoftSkillsStatus } from "../../legacy_components/UI_V2_Components/SoftSkills/SoftSkills.api";
import { SoftSkillsActionTypes } from "../../legacy_components/UI_V2_Components/SoftSkills/SoftSkills.action";
import { checkFlagValueIsV1orV2 } from "../../services/util/checkFlagValue";
import { roleAndTechSkillReduxActions } from "../../legacy_components/UI_V2_Components/Onboarding/OnboardingNewUiUx/RoleAndTechSkills/roleAndTechSkills.action";


const { Header } = Layout;
const { SubMenu } = Menu;

const token = localStorage.getItem("token");
const user = jwt.decode(token);

// Final Onboarding is only activated after admin updates users status
// Should not be auto enabled

// Algorithm is only activated after profile is completed
// const MENU_ITEMS_NOT_ON_AUTO_UPDATE = [2, 4, 5];
const MENU_ITEMS_NOT_ON_AUTO_UPDATE = [4, 5/*, 6*/];
/*
const notAvailable = 'not-looking-for-job';
const openToOffers = 'open-to-offers'
*/

export class NavigationDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Developers",
      availability: {},
      enable_LATAM_reward: null,
      name: null,
      avatar: null,
      showModal: false,
      availability_loading: true,
      selected: ["dashboard"],
      mobileDrawerOpen: false,
      pagesToHideNextStepBarFrom: [PageConstant.DASHBOARD_DEV, PageConstant.FAST_TRACK_PAGE, PageConstant.JOB_PAGE, PageConstant.NEW_PROFILE_PAGE, PageConstant.MCQ_LIST, PageConstant.ACCOUNT],
      isFlagLoaded: false,
    };
    this.handleVettingRefresh = undefined;

    this.openAvailabilityDialog = this.openAvailabilityDialog.bind(this);
    this.setUserAvailability = this.setUserAvailability.bind(this);
    this.checkPassed = this.checkPassed.bind(this);
    this.getUserData = this.getUserData.bind(this);
    this.loadWorkExpMCQ = this.loadWorkExpMCQ.bind(this);
    this.calculateMcqCount = this.calculateMcqCount.bind(this);
    this.createMenu = this.createMenu.bind(this);
    this.updateMenu = this.updateMenu.bind(this);

    this.menuItems = props.menuItems
      .filter((item) => item.type === "menuItem")
      .map((item) => {
        return {
          ...item,
          className: `${item.className || ""} mainMenuItem`,
        };
      })
      .map((item, ind) => {
        const obj = { ...item };
        if ("passed" in item) {
          if (
            ind < props.currentChallenge &&
            !MENU_ITEMS_NOT_ON_AUTO_UPDATE.includes(ind)
          ) {
            obj.passed = true;
          } else {
            obj.passed = false;
          }
        }
        if ("disabled" in item) {
          if (
            ind <= props.currentChallenge &&
            !MENU_ITEMS_NOT_ON_AUTO_UPDATE.includes(ind)
          ) {
            obj.disabled = false;
          } else {
            obj.disabled = true;
          }
        }
        return obj;
      });
    this.menu = [];
  }

  // Reset onboarding store data on logout
  ResetStoreData = () => {
    const { dispatch, LDFlags } = this.props;
    const { use_onboarding_improved_ui_ux_multi_variant } = LDFlags;
    dispatch({ type: TestsActions.RESET_DATA });
    if (use_onboarding_improved_ui_ux_multi_variant === 'v2') {
      dispatch({ type: roleAndTechSkillReduxActions.RESET_STATE_DATA });
    }
    localStorage.removeItem("lastStep");
  };

  getDeveloperAvailabilityStatuses = async () => {
    try {
      const response = await dashboardService.getDeveloperAvailabilityStatuses();
      if (response.status === CodeConstant.OK) {
        const developerAvailabilityStatuses = {};
        response.data.sort((a, b) => {
          if (a.status.toUpperCase() < b.status.toUpperCase()) return -1;
          if (a.status.toUpperCase() > b.status.toUpperCase()) return 1;
          else return 0;
        });
        response.data.forEach((item) => {
          developerAvailabilityStatuses[
            item.status.toUpperCase().replace(" ", "_")
          ] = item;
        });
        this.setState({ developerAvailabilityStatuses });
      }
    } catch (e) {
      console.log(e);
      this.setState({ developerAvailabilityStatuses: {} });
    }
  };

  async getUserData () {
    try {
      const res = await dashboardService.getUserSidebarData();
      const data = res.data.data || {};
      const name = data.full_name;
      const avatar = data.avatar;
      this.setState({ name: name ? name.split(" ")[0] : null, avatar });
    } catch (e) {
      console.log(e);
    }
  };

  setUserAvailability = async () => {
    try {
      // await this.getDeveloperAvailabilityStatuses();
      this.getUserData();
      const response = await dashboardService.getUserAvailabilityV2();

      if (response.status === CodeConstant.OK) {
        const data = response.data.data;
        const availability = data.availability_answer;
        // This is to forcibly show the av pop up because we have removed av details from onboarding form
        const { use_remove_update_fields_in_onboarding_form_v2, use_onboarding_improved_ui_ux_multi_variant, use_collect_availability_post_onboarding } = this.props.LDFlags || {};
        const newUser = localStorage.getItem('flagNewUser');
        const isModalClosed = localStorage.getItem('availability_modal_closed');
        const isV1FlagCheckPassed = use_onboarding_improved_ui_ux_multi_variant === 'v1' && checkFlagValueIsV1orV2(use_remove_update_fields_in_onboarding_form_v2)
        const forceShowModal = use_collect_availability_post_onboarding && (use_onboarding_improved_ui_ux_multi_variant === 'v2' || isV1FlagCheckPassed) && newUser === 'true' && (!isModalClosed || isModalClosed !== 'true');
        if (!availability || forceShowModal) {
          this.props.handleUserIsAvailableChange({
            userIsAvailable: undefined,
          });
          if (!isModalClosed || isModalClosed !== 'true') this.openAvailabilityDialog();
        } else {
          const userIsAvailable = !(
            availability === AVAILABILITY_STATUS_NAMES.NOT_LOOKING_FOR_JOB ||
            availability === AVAILABILITY_STATUS_NAMES.UNKNOWN
          );
          const [availabilityObj] = AvailabilityDetails.filter(
            (item) => item.value.toLowerCase() === availability.toLowerCase()
          );

          if (availabilityObj) {
            availabilityObj.last_update = data.last_update;
            /* CHANGES IN THE DATA NAME */
            availabilityObj.current_status = data.developer_availability_type;
            availabilityObj.availability_status_id = getAvailabilityId(
              data.developer_availability_type
            );
            availabilityObj.starts_in_weeks = data.starts_in_weeks;
            availabilityObj.availability_answer = availability;
          } else availabilityObj = {};

          this.props.handleUserIsAvailableChange({
            userIsAvailable,
            availabilityObj,
          });
          this.props.dispatch({
            type: ActionConstant.SAVE_AVAILABILITY_TO_STORE,
            payload: availabilityObj,
          });
        }
      } else
        this.props.handleUserIsAvailableChange({ userIsAvailable: undefined });
    } catch (e) {
      console.log(e);
      this.props.handleUserIsAvailableChange({ userIsAvailable: undefined });
    }

    this.setState({ availability_loading: false });
  };

  async loadSoftSkills() {
    this.props.dispatch({ type: SoftSkillsActionTypes.FETCH_SOFT_SKILLS_STATUS });

    try {
      const response = await getUserSoftSkillsStatus();
      const { data } = response;
      const { success } = data;
      if (success) this.props.dispatch({ type: SoftSkillsActionTypes.FETCH_SOFT_SKILLS_STATUS_SUCCESS, payload: data.data.challenge });
      else this.props.dispatch({ type: SoftSkillsActionTypes.FETCH_SOFT_SKILLS_STATUS_FAILURE, payload: data.error });
    } catch(e) {
      this.props.dispatch({ type: SoftSkillsActionTypes.FETCH_SOFT_SKILLS_STATUS_FAILURE, payload: data.error });
    }

  }

  componentDidMount() {
    this.createMenu(this.props.currentChallenge);
    this.checkPassed();
    this.loadWorkExpMCQ();
    this.loadV2Jobs();
    this.loadFastrackFlows();
    this.setUserAvailability();
    window.addEventListener("vetting-refresh", this.checkPassed);
    window.addEventListener(
      "vetting-open-availability-modal",
      this.openAvailabilityDialog
    );

    this.unlisten = this.props.history.listen(() => {
      if (this.state.mobileDrawerOpen || this.props.drawerMobileOpen) {
        this.props.toggleMobileDrawer();
      }
    });

    const { extraPassedInfo = {} } = this.props;
    if (extraPassedInfo.passedAcc) {
      // this.props.dispatch(JobsActions.FETCH_RECOMMENDED_JOBS);
      this.updateMenu();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("vetting-refresh", this.handleVettingRefresh);
    window.removeEventListener("vetting-refresh", this.checkPassed);
    window.removeEventListener(
      "vetting-open-availability-modal",
      this.openAvailabilityDialog
    );
    if (this.unlisten) {
      this.unlisten();
    }
  }

  componentWillReceiveProps(np) {
    if (
      (this.props.updateSidebar !== np.updateSidebar && np.updateSidebar) ||
      get(this.props, "availabilityData.set_availability_count", 0) !==
        get(np, "availabilityData.set_availability_count", 0) ||
      (this.props.LDFlags &&
        np.LDFlags &&
        this.props.LDFlags.$flagsReady !== np.LDFlags.$flagsReady)
    ) {
      this.setState(
        {
          enable_LATAM_reward: np.LDFlags
            ? np.LDFlags.enable_LATAM_reward
            : null,
        },
        this.checkPassed
      );
      this.props.toggleUpdateSidebar();
    } else if (
      get(this.props, "location.pathname", "") !==
      get(np, "location.pathname", "")
    ) {
      this.setState(
        {
          enable_LATAM_reward: np.LDFlags
            ? np.LDFlags.enable_LATAM_reward
            : null,
        },
        this.checkPassed
      );
    }
  }

  componentDidUpdate(np, prevState) {
    clarityIdentify(this.props.devStatus);
    if (this.props.drawerMobileOpen !== np.drawerMobileOpen) {
      this.setState({
        mobileDrawerOpen: this.props.drawerMobileOpen
      });
    }

    if ((this.state.mobileDrawerOpen !== prevState.mobileDrawerOpen) || (np.stackDemands && !isEqual(np.stackDemands, this.props.stackDemands))) {
      this.createMenu();
    }

    if (
        (np.recommendedJobsLoading === true && this.props.recommendedJobsLoading === false)
        || (np.fastrackLoading === true && this.props.fastrackLoading === false)
      ) {
      this.updateMenu();
    }

    /**
     * This ensures that MCQs are loaded only once after the flag values
     * are loaded
     */
    if (!this.state.isFlagLoaded && this.props.LDFlags.$flagsReady) {
      this.setUserAvailability();
      this.props.loadMCQData();
      this.handleVettingRefresh = event => this.props.loadMCQData();
      window.addEventListener('vetting-refresh', this.handleVettingRefresh);
      if (this.props.LDFlags.enable_soft_skills) {
        const me = this;
        (async () => {
          await me.loadSoftSkills();
        })();
      }
      this.setState({ isFlagLoaded: true });
    }

    if (this.loadingFinished(np, 'jobsV2Loading') || this.loadingFinished(np, 'jobsAppliedLoading')) {
      this.updateMenu()
    }
  }

  loadV2Jobs() {
    this.props.dispatch(JobsActions.FETCH_JOBS_V2);
  }

  valueUpdated(prevProps, key) {
    return prevProps[key] === false && this.props[key] === true
  }

  loadingFinished(prevProps, key) {
    return prevProps[key] === true && this.props[key] === false
  }

  loadJobs() {
    this.loadV2Jobs();
  }

  loadFastrackFlows() {
    this.props.dispatch(JobsActions.FETCH_FASTRACK_FLOWS);
  }

  checkPassed() {
    const { enable_latam_reward } = this.state;
    const { dispatch } = this.props;
    /* REMOVE WHEN DONE THE AB TESTING FOR PROFILE DETAIL COMPLETED */
    const profileDetailRequired = localStorage.getItem("profileDetailRequired");
    /****************************************************************/
    checkBasicChallengesPassed(profileDetailRequired).then((res) => {
      const { success, result } = res;
      this.result = res;
      if (success) {
        this.menuItems.forEach((item) => {
          if (item.path === PageConstant.REFERRAL) {
            if (result.isLATAM && enable_LATAM_reward) {
              item.title = "Refer & Win $500";
              item.navbarName = "Refer & Win $500";
            } else {
              item.title = "Refer & Win $250";
              item.navbarName = "Refer & Win $250";
            }
          }
          return item;
        });

        this.updateMenu(result);
        result.LDFlags = this.props.LDFlags || {};
        dispatch({ type: HomeActions.SET_PASSED_SECTIONS, payload: result });
      }
    });
  };

  loadWorkExpMCQ() {
    this.props.dispatch(TestsActionsDispatch.FETCH_WORK_EXP_INFO);
  };

  calculateMcqCount = () => {
    const stackDemands = this.props && this.props.stackDemands;
    let totalCount = 0;
    stackDemands && stackDemands.forEach(stack => {
      const listMCQ = stack.groups && stack.groups[0] && stack.groups[0].listMCQ;
      const mcqCount = listMCQ && listMCQ.length || 0;
      totalCount += mcqCount;
    })
    return totalCount;
  }

  updateMenu(result = {}) {
    let currentChallenge = 3;
    const {
      GetMatchedPageNewVsOld,
      gb_semi_vetted,
      gb_notification_feature,
      enable_soft_skills
    } = this.props.LDFlags || {};

    const {
      jobsV2 = [],
      isProgrammerRole = false,
    } = this.props;

    const {
      resumeCheck = false,
      extraPassedInfo: {
        passedTechStack = false,
        step_2_1st_stack_passed = false,
      } = {},
      techInterviewCheck = false,
      enableGetMatched = false,
      multiChoiceCheck = false,
      devFlowSteps: {
        step_3_enbale_ACC = false,
      } = {},
    } = result;

    const showAppliedJobMenu = jobsV2.length;

    if(showAppliedJobMenu){
      this.menuItems[2].hidden = false;
    }

    if (currentChallenge === 3) {
      if (resumeCheck) {
        this.menuItems[currentChallenge].passed = true;
        currentChallenge += 1;
      } else this.menuItems[currentChallenge].passed = false;
    }
    // Coding Challenge
    if (currentChallenge === 4) {
      if (passedTechStack)
        this.menuItems[currentChallenge].disabled = false;
      if (multiChoiceCheck && passedTechStack) {
        this.menuItems[currentChallenge].passed = true;
        currentChallenge += 1;
      } else this.menuItems[currentChallenge].passed = false;
    }

    if (!isProgrammerRole) {
      this.menuItems[4].hidden = true;
    } else {
      this.menuItems[4].hidden = false;
    }
    this.menuItems[4].passed = false;

    if (currentChallenge === 4 && isProgrammerRole) {
      if (
        (gb_semi_vetted && step_3_enbale_ACC) ||
        (!gb_semi_vetted && techInterviewCheck && step_2_1st_stack_passed)
      ) {
        this.menuItems[currentChallenge].disabled = false;
        const passed_ACC_Or_Higher_Status =
          COMPARE_STATUS(result.devStatus, STATUS.PASSED_CODING_CHALLENGE) >=
            0 && IS_VETTING_USEABLE(result.devStatus);
        if (
          (result.devFlowSteps && result.devFlowSteps.step_3_passed_ACC) ||
          result.techInterviewSchedule ||
          result.hasSchedulingNegotiationStatus ||
          passed_ACC_Or_Higher_Status
        ) {
          this.menuItems[currentChallenge].passed = true;
          currentChallenge += 1;
        }
      }
    } else if (currentChallenge === 5 && !isProgrammerRole) {
      currentChallenge += 1;
    }

    if (
      this.menuItems[6] !== undefined &&
      ((currentChallenge === 6 && GetMatchedPageNewVsOld !== "new") || enableGetMatched)
    ) {
      if (localStorage.getItem("user_login") === "true") {
        localStorage.removeItem("user_login");
        pushLog2DV2LogServer.info(
          "GET_MATCHED_LOGIN",
          "GET_MATCHED_LOGIN",
          { ...user },
          {}
        );
      }
      this.menuItems[6].disabled = false;
    }

    if (gb_notification_feature) {
      this.menuItems[1].hidden = false;
    } else {
      this.menuItems[1].hidden = true;
    }
    
    if (enable_soft_skills) {
      this.menuItems[5].hidden = false;
    }

    if (currentChallenge > 5) currentChallenge = null;
    this.props.setCurrentChallenge({
      currentChallenge,
    });
    this.currentChallenge = currentChallenge;

    this.createMenu(currentChallenge);
  };

  updateAvailability = (
    availability,
    availabilityObj = {},
    availabilityUpdated = false
  ) => {
    this.props.handleUserIsAvailableChange({
      userIsAvailable: availability,
      availabilityObj: availabilityObj || {},
      availabilityUpdated,
    });
    this.props.dispatch({
      type: ActionConstant.SAVE_AVAILABILITY_TO_STORE,
      payload: availabilityObj,
    });
  };

  checkDisabled = (item) => {
    const { devStatus, coreSkillPassed, isProgrammerRole = true, cloudRoleIds, extraPassedInfo = {}, workExpCompleted, LDFlags = {}, techInterviewCheck, turingProfileCompleted, fastrack = [], core_challenges = [], passedAdditionalMCQ=false } = this.props;
    extraPassedInfo.passedAcc = this.checkAccPassed();
    const devStatusObj = {
        cloudRoleIds,
        techInterviewCheck,
        status: devStatus,
        isProgrammerRole,
        extraPassedInfo,
        turingProfileCompleted,
        hasFastrack: fastrack.length > 0,
        coreSkillPassed,
        flags: LDFlags,
        workExpCompleted,
        passedAdditionalMCQ,
        showCoreQuiz: core_challenges.length > 0
    }

    if (item.path === PageConstant.CODING_CHALLENGE) {
      const allowed = canAccessPage('coding_challenge', devStatusObj);
      return !allowed;
    }
    else if (item.path === PageConstant.FINALIZE_RESUME) {
      const allowed = canAccessPage('finalize_resume', devStatusObj);
      return !allowed;
    }
    else if (item.path === PageConstant.JOB_PAGE) {
      return false;
    }
    else if (item.path === PageConstant.SOFT_SKILLS) {
      const allowed = canAccessPage('soft_skills', devStatusObj);
      return !allowed;
    }
    return false;
  }

  createMenu (currentChallenge, collapsed)  {
    if (!currentChallenge) currentChallenge = this.currentChallenge;
    let availabilityIcons;
    let availabilityTexts;
    let warningText;
    if (
      this.props.availabilityData &&
      this.props.availabilityData.availabilityObj
    ) {
      const { availabilityData } = this.props;
      const { availabilityObj } = availabilityData;

      const [notAvailableObj] = AvailabilityDetails.filter(
        (item) =>
          item.value.toLowerCase() ===
          AVAILABILITY_STATUS_NAMES.NOT_LOOKING_FOR_JOB
      ); /* OR .UNKNOWN ... NO MATTER, HERE JUST NEED THE OBJ WITH ICON ... */
      const [availableObj] = AvailabilityDetails.filter(
        (item) =>
          item.value.toLowerCase() ===
          AVAILABILITY_STATUS_NAMES.READY_TO_INTERVIEW
      ); /* OR .OPEN ... NO MATTER, HERE JUST NEED THE OBJ WITH ICON ... */

      const {
        availabilityIcon,
        availabilityText,
          lastUpdate,
          dateDiff,
      } = getAvailabilityState({
        availability: availabilityObj,
        availableObj,
        notAvailableObj,
      });

      availabilityIcons = availabilityIcon;
      availabilityTexts = availabilityText;
      warningText =
        lastUpdate && dateDiff > 0 ? (
          <span className="expires-warning">
            Expires in {lastUpdate}{"d. "}
            <a className="expires-warning expires-warning-update">Update</a>
          </span>
        ) : null;
    }

    const { mobileDrawerOpen } = this.state;
    const mcqCount = this.calculateMcqCount();
    let selected = ["/dashboard"];
    this.menu = [];
    this.notificationsMenu = null;
    this.menuItems.forEach((item, ind) => {
      if (item.hidden) return;
      if (item.title === "Notifications") {
        if (item.path === this.props.location.pathname) selected = [item.path];
        const { Badge } = item;
        this.notificationsMenu = (
          <Menu.Item
            key={item.path}
            disabled={item.disabled}
            data-testid="notifications"
            className={
              (item.disabled ? "menu-item-disabled" : "") +
              " " +
              (item.className || "")
            }
            onClick={() => {}}
            onItemHover={() => {}}
          >
            <Link
              to={item.path}
              onClick={item.onClick}
              className="icon navigation-icon"
              target={item.newTab ? "_blank" : null}
            >
              <span data-cy="notification" style={item.style ? item.style : {}}>
                <img
                  src={NotificationIcon}
                  alt="Notifications"
                  className="notifications"
                />{" "}
                {Notifications.Badge}
              </span>
              {item.disabled && (
                <img src={Lock} alt="Disabled" className="lock-icon" />
              )}
              {Badge ? <Badge /> : null}
            </Link>
          </Menu.Item>
        );
      } else if (!item.subMenu) {
        const isSelected = item.path === this.props.location.pathname;
        if (isSelected) selected = [item.path];
        const { Badge } = item;
        const disableItem = this.checkDisabled(item);
        this.menu.push(
          <Menu.Item
            key={item.path}
            disabled={disableItem}
            id={isSelected && mobileDrawerOpen ? "ant-menu-item-selected": ""}
            className={
              (disableItem ? "menu-item-disabled" : "") +
              " " +
              (item.className || "")
            }
          >
            <Link
              data-cy={item.title} 
              to={item.path}
              onClick={item.onClick}
              className="icon navigation-icon"
              target={item.newTab ? "_blank" : null}
            >
              <span style={item.style ? item.style : {}}>
                {item.title}
                {item.path === PageConstant.MCQ_LIST && mcqCount > 0 ? <span className="mcq-count-badge">{mcqCount}</span> : null}
              </span>
              {(disableItem) && (
                <img src={Lock} alt="Disabled" className="lock-icon" />
              )}
              {Badge ? <Badge /> : null}
              {!disableItem && mobileDrawerOpen && <img src={CaretRightIcon} className="menuMobile--arrowRight" alt="&#xf0da;"/>}
            </Link>
          </Menu.Item>
        );
      } else {
        let subMenu = [];
        item.subMenu.forEach((subItem) => {
          if (subItem.selected) selected = [subItem.path];
          subMenu.push(
            <Menu.Item key={subItem.path}>
              <Link data-cy={subItem.path} to={subItem.path} className="icon">
                <Icon className="material-icons-round">{subItem.icon}</Icon>
              </Link>
              <Link data-cy={subItem.title} to={subItem.path}>
                <span className="label">{subItem.title}</span>
              </Link>
            </Menu.Item>
          );
        });
        subMenu = (
          <SubMenu
            key={item.path}
            title={
              <span className="container">
                <Icon className="material-icons-round">{item.icon}</Icon>
                <span className="label">{item.title}</span>
              </span>
            }
          >
            {subMenu}
          </SubMenu>
        );
        this.menu.push(subMenu);
      }
    });
    
    this.menu = (
      <Menu
        key={"menu-:" + selected.join(",")}
        defaultSelectedKeys={selected}
        mode="horizontal"
        className={`mainMenu ${mobileDrawerOpen ? 'mainMenu--mobile': ''}`}
      >
        {this.menu}

        <span className={`nav-right ${mobileDrawerOpen ? 'nav-right--mobile' : ''}`}>
          {this.notificationsMenu}
          {!mobileDrawerOpen && <Button
            className={`availabilityBtn ${mobileDrawerOpen ? 'availabilityBtn--mobile': ''}`}
            shape="round"
            onClick={this.openAvailabilityDialog}
            loading={this.state.availability_loading}
          >
            {!this.state.availability_loading && (
              <React.Fragment>
                <span className="availabilityText">
                  {availabilityTexts}
                  <br /> {warningText ? warningText : null}
                </span>
                <img src={availabilityIcons} className="availabilityIcon" />
              </React.Fragment>
            )}
          </Button>}
          {mobileDrawerOpen &&
            <div
              className={`availabilityBtn ${mobileDrawerOpen ? 'availabilityBtn--mobile' : ''}`}
              onClick={this.openAvailabilityDialog}
            >
              {this.state.availability_loading && <Button loading={this.state.availability_loading} />}
              {!this.state.availability_loading && (
                <React.Fragment>
                  <div className="availabilityContent--mobile">
                    <img src={availabilityIcons} className="availabilityIcon" />
                    <span className="availabilityText">
                      {availabilityTexts}
                    </span>
                  </div>
                  {warningText && <span className="warning-text">{warningText}</span>}

                </React.Fragment>
              )}
            </div>
          }
          {!mobileDrawerOpen && <AvatarDropDown
            username={this.state.name}
            onLogout={this.handleLogout}
          />}
          {mobileDrawerOpen && <CloseIcon className="close-icon" onClick={this.props.toggleMobileDrawer} />}
        </span>
        <Menu.Item className="mainMenuItem">
            {mobileDrawerOpen && <span className="menuMobile--avatar">
                <AvatarDropDown
                    username={this.state.name}
                    onLogout={this.handleLogout}
                  />
                  <img src={CaretRightIcon} className="menuMobile--arrowRight" alt="&#xf0da;"/>
              </span>}
        </Menu.Item>
      </Menu>
    );

    this.setState({ updateUI: new Date() });
  }

  handleLogout = () => {
    const { dispatch } = this.props;

    dispatch(AuthActions.logOut)
  };

  openAvailabilityDialog = () => {
    this.setState({ showModal: true });
  };

  closeAvailabilityModal = () => {
    const { dispatch } = this.props;
    /** Sync availability with profile page if user is on profile page */
    if (window.location.pathname === PageConstant.DASHBOARD_PROFILE) {
      dispatch(ProfileActions.LOAD_USER_AVAILABILITY);
      dispatch(ProfileActions.LOAD_PROFILE_DATA);
    }
    this.setState({ showModal: false }, this.setUserAvailability);
  };

  checkAccPassed = () => {
    const { extraPassedInfo = {} } = this.props;
    return extraPassedInfo.passedAcc;
  }

  renderSideNavigation = () => {
    const ui_version_flag = this.props.LDFlags ? (this.props.LDFlags.gb_ui_ux_version || this.props.LDFlags.gb_ui_ux_improved_version) : null;
    const enableSoftSkills = this.props.LDFlags && this.props.LDFlags.enable_soft_skills ? this.props.LDFlags.enable_soft_skills : false;
    const practiceMcqFlag = ui_version_flag === 'v2_prac_mcq';
    const { mobileDrawerOpen } = this.state;
    const { availabilityData } = this.props;
    const userIsAvailable = availabilityData && availabilityData.userIsAvailable;

    const { extraPassedInfo = {}, takenSoftSkills = false, coreSkillPassed  } = this.props;
    extraPassedInfo.passedAcc = this.checkAccPassed();

    return (
      <div id="drawer_container">
        <div className="menu-scroll">
          <header
            id="app-drawer-header"
            className={mobileDrawerOpen ? "app-drawer-header--hidden" : ""}
          >
            <div id="title">
              <img
                id="turing_logo"
                data-testid="turing_logo"
                src={TuringLogoText}
                alt="Turing"
                style={{ width: "65px", height: "auto" }}
              />
            </div>
            <CloseIcon
              onClick={this.props.handleDrawerToggle}
              fontSize="large"
              className="close-icon"
            />
          </header>
          {this.menu}
        </div>
      </div>
    );
  };

  render() {
    const { drawerState, isMobileClass, availability } = this.props;
    const drawerClassName = drawerState + " " + isMobileClass;
    const { showModal } = this.state;
    return (
      <Header
        id="NavDrawer"
        data-testid="nav-drawer"
        collapsedWidth="0"
        className={drawerClassName}
        hasSider={false}
      >
        {this.renderSideNavigation()}

        {showModal && (
          <AvailabilityModalV3
            visible={showModal}
            availability={availability}
            loadData={false}
            closeAvailabilityModal={this.closeAvailabilityModal}
            handleUserIsAvailableChange={this.updateAvailability}
          />
        )}
      </Header>
    );
  }
}

const mapStateToProps = (state) => {
  return Object.assign(
    {},
    { ...state.drawer },
    { ...state.auth },
    { ...state.dashboard },
    { ...state.jobs },
    { ...state.tests },
    { ...state.home },
    state.softSkills 
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    collapseDrawer: (payload) =>
      dispatch(DrawerActions.collapseDrawer(payload)),
    authenticate: (payload) => dispatch(AuthActions.authenticate(payload)),
    setCurrentChallenge: (payload) =>
      dispatch(DrawerActions.setCurrentChallenge(payload)),
    handleUserIsAvailableChange: (payload) =>
      dispatch(DrawerActions.setAvailabilityObj(payload)),
    toggleMobileDrawer: () => dispatch(DrawerActions.toggleMobileDrawer()),
    loadMCQData: () => dispatch(TestsActionsDispatch.LOAD_MCQ_CHALLENGES_V2)
  };
};


export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withLDFlagsFromBackend(NavigationDrawer, [GB_FLAGS.enable_latam_reward, GB_FLAGS.gb_ui_ux_version, GB_FLAGS.gb_ui_ux_improved_version, GB_FLAGS.gb_ui_ux_version_step_2_3, GB_FLAGS.gb_notification_feature, GB_FLAGS.mcq_use_apiv1, GB_FLAGS.enable_soft_skills, GB_FLAGS.use_remove_update_fields_in_onboarding_form_v2, GB_FLAGS.use_onboarding_improved_ui_ux_multi_variant, GB_FLAGS.use_role_based_mcq_uiux, GB_FLAGS.use_collect_availability_post_onboarding]))
);
